document.addEventListener("DOMContentLoaded", function () {
  // Capturar la sección de pestañas
  var productTab = document.querySelector("section.tabs-product");

  // Capturar el elemento con la clase product_custom_html
  var paymentImage = document.querySelector("div.product_custom_html");

  // Verificar que ambos elementos existan
  if (productTab && paymentImage) {
    // Mover la sección después del div.product-payment-image
    paymentImage.insertAdjacentElement("afterend", productTab);
  }
});